"use client";

import dynamic from "next/dynamic";

// Lazy load the map component to keep the page SSR-friendly
// The map requires client-side rendering and heavy dependencies
const USCoverageMap = dynamic(
	() =>
		import("./USCoverageMap").then((mod) => ({
			default: mod.USCoverageMap,
		})),
	{
		ssr: false, // Disable SSR for this component
		loading: () => (
			<div className="w-full text-white min-h-[600px] flex items-center justify-center">
				<div className="text-center">
					<div className="w-16 h-16 border-4 border-[#2a3f32] border-t-[#A7FF5E] rounded-full animate-spin mx-auto mb-4"></div>
					<div className="text-[#A7FF5E]">
						Loading Coverage Map...
					</div>
				</div>
			</div>
		),
	}
);

export default function USCoverageMapLazy() {
	return <USCoverageMap />;
}
